import React, {useContext, useState} from 'react'
import noteContext from '../context/notes/noteContext'
const Noteitem = (props) => {
  const context = useContext(noteContext);
  const {deleteNote, editNote} = context; // De structuring
  const {note} = props;
  const [noteitem, setnoteitem] = useState(note);
  
  // Changing state of note when typing in textfield
  const onChange = (e)=>{
    e.preventDefault();
      // ...note => jo chiz note me phele se hai vo rahe
      // baki usme ab ye chiz add karo ya overwrite karo
      let content = e.target.value;
      if(content.charAt(content.length-1)!=' ')content = content.trim();
      else content = content.trim() + " ";
      setnoteitem({...noteitem, [e.target.name]:content})
  }
  
  return (
    <>
    <div className="card col-md-3 mx-2 my-3">
    <div className="card-body">
        <h5 className="card-title" data-toggle="modal" data-target={`#exampleModalCenter${noteitem._id}`}>{noteitem.title}</h5>
        <p className="card-text" data-toggle="modal" data-target={`#exampleModalCenter${noteitem._id}`}>{noteitem.description.slice(0,100)}
        {noteitem.description.length>100? '...':''}</p>
        {/* <a style={{'color':'blue'}} >(view)</a><br/> */}
        
        {props.notetype!=='global'?
        <i className="fa-solid fa-trash mx-2 my-2 down" style={{right:'0',bottom: '0',position: 'absolute'}} onClick={()=>{deleteNote(noteitem._id); props.showAlert("Message Deleted", "danger")}}></i> : ""}
    </div>
    </div>
    {/* Modal to display entire note details */}
      <div className="modal fade" id={`exampleModalCenter${noteitem._id}`} tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">
                <label htmlFor="exampleInputEmail1">Title</label>
                <input type="text" className="form-control" id="title" name="title" value={noteitem.title} onChange={props.notetype!=='global'?onChange:""} aria-describedby="emailHelp" placeholder="Enter title"/>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label htmlFor="exampleInputPassword1">Description</label>
              <textarea type="text" className="form-control" id="description" name="description" value={noteitem.description} onChange={props.notetype!=='global'?onChange:""} placeholder="Description" minLength={5}/>
              <label htmlFor="tag">Tag</label>
              <input type="text" className="form-control" id="tag" name="tag" value={noteitem.tag} onChange={props.notetype!=='global'?onChange:""} placeholder="tag"/>
            </div>
            <div class="modal-footer">
            {/* Editing Note */}
              {props.notetype!=='global'?
              <button type="button" class="btn btn-secondary" onClick={()=>{editNote(noteitem)}} data-dismiss="modal">Update</button> : ""}
              
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Noteitem